module.exports = __webpack_public_path__ + "img/7up.dbe34f13.jpg";